import { CommonMessage } from '@frontend/lang';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import useLoadMoreButton from './load-more-button.controller';

const ID = 'load-more-button';
export interface LoadMoreButtonProps {
    listId: string;
    dispatch: ThunkDispatch<any, any, Action>;
}

const LoadMoreButton = (props: LoadMoreButtonProps) => {
    const viewProps = useLoadMoreButton(props);

    if (viewProps.disabled) return <></>;

    if (viewProps.isLoading) return (
        <li id={ID}
            className='w-full text-center text-secondary text-sm font-medium py-3 animate-pulse'
            onClick={viewProps.nextPage}>
            Loading
        </li>
    );
    
    return (
        <li id={ID}
            className='w-full text-center text-secondary text-sm font-medium py-3'
            onClick={viewProps.nextPage}>
            {CommonMessage.LISTS.LOAD_MORE}
        </li>
    );
};

export default LoadMoreButton;
